import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";
import instance from "../../axios";

//   api/ads/?mosque_id=2
//   api/ads/?mosque_id=2&category_id=1
export default function AllMosqueAds() {
  const { mosqueIdAds } = useParams();

  const [mosqueAdsArr, setMosqueAdsArr] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    instance
      .get(`api/ads/?mosque_id=${mosqueIdAds}`)
      .then((res) => {
        setMosqueAdsArr(res.data.data.ads);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  }, [mosqueIdAds]);

  const statusFilter = (status) => {
    switch (status) {
      case 1:
        return "Aktiv";
      case 2:
        return "Bekor qilingan";
      case 3:
        return "Kutilmoqda";
      default:
        return "";
    }
  };

  if (loading) {
    return (
      <div className="container mx-auto p-2">
        <h1 className="text-3xl text-gray-400 text-center">yuklanmoqda...</h1>
      </div>
    );
  }

  if (!loading && mosqueAdsArr.length === 0) {
    return (
      <div className="container mx-auto p-2">
        <h1 className="text-3xl text-gray-400 text-center">E'lonlar yo'q</h1>
      </div>
    );
  } else {
    return (
      <div className="container mx-auto p-2">
        <h1 className="mb-3 text-2xl font-semibold text-center text-gray-600">
          Masjid e'lonlari
        </h1>
        <div>
          {mosqueAdsArr?.map((ad) => {
            return (
              <Link to={`/announcement/${ad?.id}/help`}>
                <div className=" flex-column block p-3 mb-3 border border-gray-100 shadow-xl rounded-xl bg-white">
                  <div className="mt-2 text-gray-500 sm:pr-8">
                    <h5 className="text-center text-xl font-bold text-gray-900">
                      {ad?.name}
                    </h5>
                  </div>
                  <div className="mt-2">
                    <p>
                      Miqdor:
                      <span className="ml-1 text-lg font-medium">
                        {`${ad?.amount} ${ad?.amount_type}`}
                      </span>
                    </p>
                    <p>
                      Kategoriya:
                      <span className="ml-1 text-lg font-medium">
                        {ad?.category?.name}
                      </span>
                    </p>
                    <p>
                      Yig'ilgan:
                      <span className="ml-1 text-lg font-medium">
                        {ad?.totalHelp || 0}
                      </span>
                    </p>
                    <p>
                      Holat:
                      <span
                        className={`ml-1 text-${
                          ad.status === 1
                            ? "green"
                            : ad.status === 2
                            ? "red"
                            : ad.status === 3
                            ? "orange"
                            : "gray"
                        }-600 font-medium text-xl `}>
                        {statusFilter(ad?.status)}
                      </span>
                    </p>
                    <p>
                      Kategoriya:
                      <span className="ml-1 text-lg font-medium">
                        {ad?.category.name}
                      </span>
                    </p>
                    <p>
                      Yordamlar soni:
                      <span className="ml-1 text-lg font-medium">
                        {ad?.requests?.length || 0}
                      </span>
                    </p>

                    {ad?.text && (
                      <p>
                        Qo'shimcha ma'lumot:
                        <span className="ml-1 text-gray-400">{ad?.text}</span>
                      </p>
                    )}
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    );
  }
}
